import { render } from "./menu-box.vue?vue&type=template&id=bfacd5b8"
import script from "./menu-box.vue?vue&type=script&lang=js"
export * from "./menu-box.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__